import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { FormBuilder } from './FormBuilder';
import { formTypeFromQueryParam } from '../../utils/constants';

/** Route adapter for /forms/new, /forms/edit/:formId, and /forms/template/:templateId. */
export const SingleFormContent = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { formId, templateId } = useParams<{ formId?: string; templateId?: string }>();

    const isNewForm = location.pathname === '/forms/new';
    const isEditTemplateMode = Boolean(location.pathname.startsWith('/forms/template/') && templateId);
    const sourceFormId = searchParams.get('fromFormId') || undefined;

    const defaultFormType = formTypeFromQueryParam(searchParams.get('type'));

    return (
        <FormBuilder
            variant="page"
            formId={formId}
            templateId={templateId}
            sourceFormId={isNewForm ? sourceFormId : undefined}
            isNewForm={isNewForm}
            isEditTemplateMode={isEditTemplateMode}
            defaultFormType={isNewForm ? defaultFormType : undefined}
            manageNavigationGuard
        />
    );
};
